import React from 'react'
import {BiArrowBack} from 'react-icons/bi'

const BackButton = ({linkTo="/", size=15, onClick}) => {
  return (
    <div>

        <button onClick={onClick} className='round-back-button'>
            <BiArrowBack
            size={size}
            color={"white"}
            />
        </button>

</div>
  )
}

export default BackButton
